<template>
  <div style="position: relative" class="my-2 leaflet-bar all-in-one-search" :id="'all-in-one-search' + rnd">
    <a href="#" @click.stop.prevent="opened = !opened" class="leaflet-bar-part leaflet-bar-part-single all-in-one-search-button"><i class="fa fa-search"></i></a>
    <all-in-one-geo-autocomplete class="all-in-one-search-input" v-if="opened" @selected="setViewData"></all-in-one-geo-autocomplete>
  </div>
</template>

<script>
import { polyline } from 'leaflet'
import AddressMixin from '@/mixins/address.mixin'
import AllInOneGeoAutocomplete from '@/components/Autocompletes/AllInOneGeoAutocomplete'

export default {
  name: 'AllInOneSearch',
  components: {
    AllInOneGeoAutocomplete
  },
  data() {
    return {
      opened: false,
      rnd: Math.floor(Math.random() * 99999999999999) + 1
    }
  },
  watch: {
    opened(val) {
      if (val) {
        setTimeout(() => {
          document.querySelector('#all-in-one-search' + this.rnd + ' input').focus()
        }, 200)
      }
    }
  },
  mixins: [
    AddressMixin
  ],
  methods: {
    async setViewData(item) {
      if (item.external_id) {
        this.$emit('bounds-updated', this.getBounds(item))
      } else {
        await this.checkPlace(item)
        this.$emit('center-updated', [this.theCheckedAddress.lat, this.theCheckedAddress.lng])
      }
    },
    getBounds(x) {
      let element
      let coordinates
      if (x.fence) {
        coordinates = x.fence.coordinates
      } else {
        coordinates = x.path ? x.path.coordinates : [x.lat, x.lng]
      }
      // For map
      let cleanupDupes = x.fence?.coordinates ? [Array.from(new Set(coordinates[0].map(a => a.join('|'))), s => s.split('|').map(Number))] : null
      coordinates = cleanupDupes ? cleanupDupes.map(x =>
        x.map(([lng, lat]) => ({lat, lng}))
      ) : coordinates

      if (coordinates[0]?.length > 1) {
        element = polyline(coordinates)
        return [
          element.getBounds().getSouthWest(),
          element.getBounds().getNorthEast()
        ]
      } else {
        return coordinates
      }
    }
  }
}
</script>

<style lang="scss" scoped>
a.all-in-one-search-button {
  border-radius: 4px !important;
}
.all-in-one-search-input {
  position: absolute;
  top: -2px;
  left: 35px;
  width: 260px !important;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);
  border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
